module.exports = __webpack_public_path__ + "img/safari_close.03cfddde.png";